module.exports = __webpack_public_path__ + "80000fe3f70b3059a202c0c3926ea953.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgnw_c.png
// module id = 300
// module chunks = 3